import {
  Activity,
  Baby,
  Heart,
  Waves,
  ScanLine,
  Bone,
  Stethoscope,
  CircleDot,
} from "lucide-react";

const SERVICES = [
  {
    icon: Activity,
    title: "Ultrasound / Sonography",
    desc: "High-resolution abdominal, pelvic and small-parts ultrasound with same-day reporting.",
  },
  {
    icon: Baby,
    title: "Pregnancy Sonography",
    desc: "Routine antenatal scans, anomaly and growth scans with patient-friendly explanations.",
  },
  {
    icon: Heart,
    title: "3D / 4D Scan",
    desc: "Beautiful real-time imaging of your baby — printed snapshots and digital memories.",
  },
  {
    icon: Waves,
    title: "Colour Doppler",
    desc: "Vascular and obstetric Doppler studies for arteries, veins and foetal blood flow.",
  },
  {
    icon: ScanLine,
    title: "Digital X-Ray",
    desc: "Low-dose digital X-rays with crisp clarity, ready in minutes.",
  },
  {
    icon: Bone,
    title: "Dental OPG X-Ray",
    desc: "Panoramic dental imaging for orthodontic and oral surgery referrals.",
  },
  {
    icon: Stethoscope,
    title: "Thyroid / Abdomen / Pelvis Scan",
    desc: "Focused organ-specific scans with detailed clinical reports.",
  },
  {
    icon: CircleDot,
    title: "Obstetric Sonography",
    desc: "First, second and third trimester sonography by an experienced radiologist.",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-20 lg:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-[#0099CC]">
            Our Services
          </span>
          <h2
            className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900"
            data-testid="services-title"
          >
            Comprehensive Diagnostic Imaging,{" "}
            <span className="text-[#0099CC]">All Under One Roof</span>
          </h2>
          <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">
            Every study at Nidan is performed on modern equipment and interpreted by an
            experienced radiologist — so you walk out with clarity, not questions.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {SERVICES.map((s) => (
            <article
              key={s.title}
              data-testid={`service-card-${s.title.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}
              className="group bg-white p-6 rounded-2xl border border-slate-100 shadow-[0_4px_20px_rgba(15,23,42,0.03)] hover:shadow-[0_18px_40px_rgba(15,23,42,0.08)] hover:-translate-y-1 transition-all duration-300 flex flex-col h-full"
            >
              <div className="w-12 h-12 rounded-2xl bg-[#00BFFF]/10 text-[#0099CC] flex items-center justify-center group-hover:bg-[#00BFFF] group-hover:text-white transition-colors">
                <s.icon className="w-6 h-6" strokeWidth={2} />
              </div>
              <h3 className="mt-5 text-lg font-semibold text-slate-900">{s.title}</h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{s.desc}</p>
              <div className="mt-5 pt-4 border-t border-slate-100 flex items-center justify-between text-xs font-medium text-slate-500">
                <span className="inline-flex items-center gap-1.5">
                  <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
                  Fast reporting
                </span>
                <span>Comfortable experience</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
